const rankings = [
  { rank: 1, title: '霸道总裁的契约恋人', category: '韩漫腐', heat: '本周热度 128.6w', change: 'up' },
  { rank: 2, title: '剑影风华录', category: '国漫耽美', heat: '本周热度 115.3w', change: 'up' },
  { rank: 3, title: '樱花树下的约定', category: '日漫腐', heat: '本周热度 98.7w', change: 'same' },
  { rank: 4, title: '异世界魔王的宠妃', category: '韩漫耽美', heat: '本周热度 87.2w', change: 'down' },
  { rank: 5, title: '恋爱吧少年', category: '国漫耽美', heat: '本周热度 76.5w', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            人气排行
          </h2>
          <p className="mt-2 text-sm text-foreground-500">本周最受读者欢迎的腐漫作品 TOP5</p>
        </div>

        <div className="flex flex-col gap-3">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer group"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl">
                {item.rank === 1 ? (
                  <i className="ri-medal-line text-accent-500 text-xl md:text-2xl w-6 h-6 md:w-7 md:h-7 flex items-center justify-center"></i>
                ) : item.rank === 2 ? (
                  <i className="ri-medal-line text-foreground-300 text-xl md:text-2xl w-6 h-6 md:w-7 md:h-7 flex items-center justify-center"></i>
                ) : item.rank === 3 ? (
                  <i className="ri-medal-line text-secondary-500 text-xl md:text-2xl w-6 h-6 md:w-7 md:h-7 flex items-center justify-center"></i>
                ) : (
                  <span className="text-lg md:text-xl font-bold text-foreground-300">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">{item.category}</p>
              </div>

              <div className="flex-shrink-0 text-right">
                <span className="text-xs md:text-sm font-medium text-foreground-600 whitespace-nowrap">{item.heat}</span>
                <span className={`ml-2 inline-flex items-center w-5 h-5 justify-center`}>
                  {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-primary-500 text-sm"></i>}
                  {item.change === 'same' && <i className="ri-subtract-line text-foreground-300 text-sm"></i>}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}